// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__C0WwI","container":"style_container__3CTeu","identicon":"style_identicon__1z4iW","avatar":"style_avatar__2ofpZ","version":"style_version__2tuEY"};